module.exports = __webpack_public_path__ + "img/rank18.e7e3f42c.png";